/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faGameBoard} from '@fortawesome/pro-duotone-svg-icons';

const SchedulerGameBoardIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faGameBoard} {...props} />
);

export default SchedulerGameBoardIcon;
